/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { PageLayout } from '../common/PageLayout';
import { useSelect, useSelectWithParams } from '../../../utils/selector.utils';
import { pageStateSelectors } from '../../../app/page/page-state/page-state.selectors';
import { authSelectors } from '../../../app/auth/auth.selectors';
import { openDialog } from '../../../app/dialog/dialog.actions';
import { initialAgencyToolsPage } from '../../../app/page/agency-tools/agency-tools.actions';
import { companyToolsCategoriesPageSelectors } from '../../../app/page/page-storage/company-tools-categories/company-tools-categories.selectors';
import { CompanyToolsCategory } from './CompanyToolsCategory';
import { DefaultChartCategory } from './DefaultChartCategory';

export const AgencyToolsPage: FunctionComponent = () => {
  const dispatch = useDispatch();

  const showLoader = useSelectWithParams(pageStateSelectors.selectPageInProgress, 'agencyTools');
  const isAdmin = useSelect(authSelectors.selectUserIsAdmin);

  useEffect(() => {
    dispatch(initialAgencyToolsPage());
  }, [dispatch]);

  const companyToolsCategoryIds = useSelect(companyToolsCategoriesPageSelectors.selectCompanyToolsCategories);

  return (
    <PageLayout showLoader={showLoader}>
      <div className="row mb-25">
        <div className="col-12">
          <div className="panel">
            <div className="no-border panel-header small-header">
              <h2 className="bold">Agency Tools</h2>
              {isAdmin && (
                <div className="ml-auto flex aic jcr">
                  <a
                    className="btn btn-md themed-bg"
                    title="Add Category"
                    onClick={() => dispatch(openDialog('companyToolsCategoryFormDialog'))}
                  >
                    <i className="icon-plus mr-1"></i> Add Category
                  </a>
                </div>
              )}
            </div>
            <div className="agency-tools panel-body">
              <div className="border-radius-1 lightGray-bg p-5">
                <div className="row big-gap agency-tools-class">
                  {!showLoader && (
                    <>
                      <div className="col-4 px-2 mb-5 agency-tools-column" key="org-chart">
                        <DefaultChartCategory />
                      </div>
                      {companyToolsCategoryIds.map((companyToolsCategoryId) => (
                        <div className="col-4 px-2 mb-5 agency-tools-column" key={companyToolsCategoryId}>
                          <CompanyToolsCategory companyToolsCategoryId={companyToolsCategoryId} />
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};
